import { of } from "rxjs";
import { catchError, filter, map, mergeMap } from "rxjs/operators";

import { Effect } from "../../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../../redux/types/effect-actions-observable.type";
import { isActionType } from "../../../../redux/action.functions";

import { FileDownloadActions } from "./file-download.actions";
import * as actions from "./file-download.actions";
import * as services from "../services/file-download.service";
import { addMessage } from "../../../../redux/actions/messagesActions";

const download: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(FileDownloadActions.Download)),
    map((action) => action.payload),
    mergeMap((payload) =>
      services.downloadFile(payload.url, payload.authRequired, payload.accept).pipe(
        map((response) => actions.downloadSuccess(response, payload.fallbackName)),
        catchError((error) => of(actions.downloadFailure(error)))
      )
    )
  );

const downloadFailure: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(FileDownloadActions.DownloadFailure)),
    map(() => addMessage({ text: "A problem occurred. Please try again.", severity: "error" }))
  );

const downloadSuccess: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(FileDownloadActions.DownloadSuccess)),
    map((action) =>
      services.handleFileDownload(action.payload.response, action.payload.fallbackName)
    ),
    map(() => addMessage({ text: "File ready.", severity: "success" }))
  );

export const FileDownloadEffects = [download, downloadFailure, downloadSuccess];
